//--------------------PAGE ROUTES-----------------------------------
export var PATH_DASHBOARD = window.location.origin + '/Home/Landing';
export var PATH_ACCOUNT_LOGOFF = window.location.origin + '/Account/Logoff/'; // LOGIN UI login/logout routes & paths

export var ROUTE_LOGIN_EXPIRED = '/ui/login/expired';
export var ROUTE_LOGIN_LOGOUT = '/ui/login/logout';
export var PATH_LOGIN_EXPIRED = window.location.origin + ROUTE_LOGIN_EXPIRED;
export var PATH_LOGIN_LOGOUT = window.location.origin + ROUTE_LOGIN_LOGOUT; //-------------------FEATURE TOGGLES---------------------------------

export var REQUIRE_AUTH = true;